import React from "react";
import PlusCircleIcon from "src/assets/icons/plusCircle.svg";

interface Props {
  onClick?: () => void;
  className?: string;
  id?: string;             // optional id prop added
  ariaLabel?: string;      // optional aria-label prop added
}

function AddButton(props: Props) {
  return (
    <button
      id={props.id ?? "btn-add-button"}
      onClick={props.onClick}
      aria-label={props.ariaLabel ?? "Add new item"}
      className={
        "flex h-[48px] w-[48px] rounded-full items-center justify-center bg-black " +
        (props.className ?? "")
      }
    >
      <img
        src={PlusCircleIcon}
        className="h-[24px] w-[24px] dark:invert"
        alt="Add icon"
      />
    </button>
  );
}

export default AddButton;
